// Bacha Way Travel WhatsApp configuration.
export const WHATSAPP_NUMBER = "212600876933";

export function isWhatsAppConfigured(): boolean {
  return /^\d{8,15}$/.test(WHATSAPP_NUMBER);
}

export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

